// extracted by mini-css-extract-plugin
export default {"controlPanel":"ControlPanel_controlPanel__SszIz","controlButton":"ControlPanel_controlButton__zwmry","errorPanel":"ControlPanel_errorPanel__HH9NA"};